import React from "react";
import { Input, Button, Table, Radio, List } from "antd";

const columns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    defaultSortOrder: "descend",
    sorter: (a, b) => b.name.localeCompare(a.name)
  },
  {
    title: "Subject",
    dataIndex: "subject",
    key: "subject",
    sorter: (a, b) => b.subject.localeCompare(a.subject)
  },
  {
    title: "Created",
    dataIndex: "created",
    key: "created",
    sorter: (a, b) => b.created - a.created
  },
  {
    title: "Case",
    dataIndex: "case",
    key: "case",
    sorter: (a, b) => b.case - a.case,
    render: state => <Radio defaultChecked={state} name="tratata" value="1" />
  },
  {
    title: "Control",
    dataIndex: "control",
    key: "control",
    sorter: (a, b) => b.control - a.control,
    render: state => <Radio defaultChecked={state} name="tratata" value="2" />
  }
];

const data = [
  {
    id: 0,
    key: 0,
    name: "Sample 1",
    subject: "MOLT 4",
    created: "10/10/18",
    case: true,
    control: false
  },
  {
    id: 1,
    key: 1,
    name: "Sample 2",
    subject: "MOLT 4",
    created: "10/10/18",
    case: false,
    control: true
  },
  {
    id: 2,
    key: 2,
    name: "Sample 3",
    subject: "MOLT 4",
    created: "10/10/18",
    case: false,
    control: true
  },
  {
    id: 3,
    key: 3,
    name: "Sample 4",
    subject: "MOLT 4",
    created: "10/10/18",
    case: false,
    control: false
  },
  {
    id: 4,
    key: 4,
    name: "Sample 5",
    subject: "MOLT 4",
    created: "10/10/18",
    case: false,
    control: false
  },
  {
    id: 5,
    key: 5,
    name: "Sample 6",
    subject: "MOLT 4",
    created: "10/10/18",
    case: false,
    control: false
  }
];

const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {
    console.log(
      `selectedRowKeys: ${selectedRowKeys}`,
      "selectedRows: ",
      selectedRows
    );
  },
  getCheckboxProps: record => ({})
};

class StepOne extends React.Component {
  render() {
    const caseSamles = ["Samples 1"];
    const controlSamles = ["Samples 2", "Samples 3"];
    return (
      <div className="analysis__step analysis__step_one">
        <div className="analysis__head">
          <div className="analysis__name">
            <div className="analysis__label label">Analysis name</div>
            <Input placeholder="Enter analysis Name" />
          </div>
          <div className="analysis__actions">
            <Button className="ant-btn-no-border">Add to case</Button>
            <Button className="ant-btn-no-border">Add to control</Button>
          </div>
        </div>
        <div className="analysis__layout">
          <div className="analysis__grid">
            <Table
              className="analysis__table"
              rowSelection={rowSelection}
              columns={columns}
              dataSource={data}
              pagination={false}
              size="small"
            />
          </div>
          <div className="analysis__col">
            <List
              className="analysis__list"
              header="Case Samples"
              dataSource={caseSamles}
              renderItem={item => <List.Item>{item}</List.Item>}
            />
          </div>
          <div className="analysis__col">
            <List
              className="analysis__list"
              header="Control Samples"
              dataSource={controlSamles}
              renderItem={item => <List.Item>{item}</List.Item>}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default StepOne;
